// Use empty string for same-origin requests (proxied via Vite proxy)
const API_BASE_URL = '';
const TOKEN_KEY = 'matricks_bearer_token';

// Token management utilities
export function getStoredToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(TOKEN_KEY);
}

// Get authorization header for API calls
export function getAuthHeader(): Record<string, string> {
  const token = getStoredToken();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}

// Better-auth client is not used - we have custom bearer token auth
// Export an empty object to maintain compatibility
export const authClient = Object.freeze({});


